import { api } from "./client";
import { runParamsFromConfig } from "../lib/run-params";
import type { RunParams } from "../lib/types";

export function getRuntime() {
  return api<Record<string, unknown>>("/api/v1/settings/runtime");
}

export function getConfig() {
  return api<{ config: Record<string, unknown>; paths: Record<string, unknown> }>("/api/v1/settings/config");
}

export function saveConfig(config: Record<string, unknown>) {
  return api<{ message: string; config: Record<string, unknown> }>("/api/v1/settings/config", {
    method: "PUT",
    body: JSON.stringify({ config })
  });
}

export function saveOpenKey(openKey: string) {
  return api<{ message: string; open_key_configured: boolean }>("/api/v1/settings/open-key", {
    method: "PUT",
    body: JSON.stringify({ open_key: openKey })
  });
}

export function clearOpenKey() {
  return api<{ message: string; open_key_configured: boolean }>("/api/v1/settings/open-key", { method: "DELETE" });
}

export function testProxy(proxyUrl: string) {
  return api<{ ok: boolean; exit_ip?: string; duration_ms?: number; resolved_proxy_summary?: string; error?: string }>("/api/v1/settings/proxy/test", {
    method: "POST",
    body: JSON.stringify({ proxy_url: proxyUrl })
  });
}

export async function getRunParams() {
  const { config } = await getConfig();
  return runParamsFromConfig(config);
}

export async function saveRunParams(params: RunParams) {
  const { config } = await getConfig();
  const response = await saveConfig({ ...config, default_run_params: params });
  return { ...response, run_params: runParamsFromConfig(response.config) };
}
